<template>
  <f7-page>
    <f7-navbar :title="$t('title.pageNotFound')" :back-link="$t('action.back')"></f7-navbar>
  </f7-page>
</template>

<script>
  export default {
    name: 'page-not-found'
  }
</script>

<style scoped>

</style>
